import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FieldDataChangedEvent } from "devextreme/ui/form";

const TEXT_MAX_LENGTH = 256;

@Component({
  selector: "snt-report-form-renderer-text",
  templateUrl: "report-form-renderer-text.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererTextComponent implements OnInit {
  @Input()
  item!: any;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readOnly: boolean = false;

  @Output()
  value: EventEmitter<string> = new EventEmitter();

  readonly textMaxLength = TEXT_MAX_LENGTH;

  formData = {
    value: ""
  };

  get currentTextLength(): number {
    return this.formData.value?.length ?? 0;
  }

  ngOnInit(): void {
    this.formData.value = this.item.text || this.item.value || "";
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "text",
      config: {
        title: this.item.config.title,
        value: this.formData.value
      }
    };
  }

  onFieldDataChanged({ value, dataField }: FieldDataChangedEvent): void {
    this.item.value = value;

    this.value.emit(value);
  }
}
